import { useState } from 'react';

const formatDistance = (meters) => (
  meters >= 1000 ? `${(meters / 1000).toFixed(2)} km` : `${Math.round(meters)} m`
);

/**
 * Google Maps' own "measure distance" (from its right-click menu) isn't
 * exposed by the public JS API - this is our own equivalent, built on the
 * geometry library (already loaded for route decoding) rather than any
 * ready-made measuring widget.
 */
export const useMeasureTool = () => {
  const [isMeasuring, setIsMeasuring] = useState(false);
  const [measurePoints, setMeasurePoints] = useState([]);

  const toggleMeasuring = () => {
    setIsMeasuring((prev) => {
      const next = !prev;
      // Only clear when starting a fresh measurement, so the finished line
      // and its distance stay visible after you stop measuring.
      if (next) setMeasurePoints([]);
      return next;
    });
  };

  const addMeasurePoint = (point) => {
    setMeasurePoints((prev) => [...prev, point]);
  };

  const clearMeasurement = () => setMeasurePoints([]);

  const distanceMeters = (measurePoints.length > 1 && typeof google !== 'undefined' && google.maps && google.maps.geometry)
    ? google.maps.geometry.spherical.computeLength(measurePoints.map((point) => new google.maps.LatLng(point.lat, point.lng)))
    : 0;

  return {
    isMeasuring,
    measurePoints,
    toggleMeasuring,
    addMeasurePoint,
    clearMeasurement,
    distanceLabel: measurePoints.length > 1 ? formatDistance(distanceMeters) : null,
  };
};
